import { useState } from 'react'
import { Button } from '@/components/ui/Button'
import { Input } from '@/components/ui/Input'
import { Label } from '@/components/ui/Label'
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/Dialog'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/Select'
import type { RedirectRule } from './redirectTypes'

interface RedirectRuleFormProps {
  rule: RedirectRule | null
  open: boolean
  onOpenChange: (open: boolean) => void
  onPreview: (rule: RedirectRule) => void
}

export function RedirectRuleForm({ rule, open, onOpenChange, onPreview }: RedirectRuleFormProps) {
  const [source, setSource] = useState(rule?.source ?? '')
  const [destination, setDestination] = useState(rule?.destination ?? '')
  const [status, setStatus] = useState<301 | 302>(rule?.status ?? 301)
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader><DialogTitle>{rule ? 'Edit redirect' : 'Add redirect'}</DialogTitle></DialogHeader>
        <form className="space-y-4" onSubmit={event => {
          event.preventDefault()
          onPreview({ source: source.trim(), destination: destination.trim(), status })
          onOpenChange(false)
        }}>
          <div className="space-y-2"><Label htmlFor="redirect-source">Old path</Label>
            <Input id="redirect-source" value={source} onChange={e => setSource(e.target.value)} placeholder="/old-guide" required /></div>
          <div className="space-y-2"><Label htmlFor="redirect-destination">Current path</Label>
            <Input id="redirect-destination" value={destination} onChange={e => setDestination(e.target.value)} placeholder="/articles/current-guide" required /></div>
          <Select value={String(status)} onValueChange={v => setStatus(v === '302' ? 302 : 301)}>
            <SelectTrigger aria-label="Redirect status"><SelectValue /></SelectTrigger>
            <SelectContent><SelectItem value="301">301 — Permanent</SelectItem><SelectItem value="302">302 — Temporary</SelectItem></SelectContent>
          </Select>
          <Button type="submit">Preview change</Button>
        </form>
      </DialogContent>
    </Dialog>
  )
}
